<app-unified-header [title]="!bedId ? 'Add Bed' : isReadMode ? 'Bed Details' : 'Edit Bed'" (onSave)="manageBed()"
  defaultHref="/bed-list" [restrictBack]="bedDetailsForm && !bedDetailsForm.pristine"
  [saveBtn]="{title: bedId && isReadMode ? 'Edit' : 'Save', isDisable: bedId && isReadMode ? false : isSaveDisabled, rule: bedId ? 'putBed' : ''}"
  [isRootPage]="isRootPage"></app-unified-header>

<ion-content *ngIf="bedDetailsForm">
  <form [formGroup]="bedDetailsForm">
    <ng-container *ngFor="let config of bedDetailsInputConfig">
      <unified-input ngDefaultControl [formControlName]="config.name || null" [config]="getConfig(config)"
        (changed)="inputChanged($event)"></unified-input>
    </ng-container>
    <ion-item *ngIf="f['connexioEnabled']?.value == true">
      <ion-label>SafeLight Installed</ion-label>
      <ion-toggle mode="ios" color="controls" slot="end" formControlName="ublInstalled"
        *ngIf="!bedId || (bedId && !isReadMode && isEditable)"
        (ionChange)="onLightInstalledChange($event)"></ion-toggle>
      <div slot="end" class="custom-input" *ngIf="bedId && (isReadMode || !isEditable)">
        <ion-input [value]="f['ublInstalled']?.value ? 'Yes' : 'No'" readonly></ion-input>
      </div>
    </ion-item>
    <div class="detail-block" *ngIf="bedId">
      <ion-item class="form-item-detail first-item-border" [detail]="!isReadMode"
        [ngClass]="{'interactive': !isReadMode}" (click)="setRoom()">
        <ion-label>Room</ion-label>
        <ion-text slot="end" [class.app-link]="f['roomName']?.value && isReadMode"
          [class.no-link]="!isRoomSummaryEnabled" [class.none-value]="!f['roomName']?.value">{{f['roomName']?.value ||
          (isReadMode ? 'Unassigned' : 'None')}}<span
            *ngIf="isReadMode && f['roomName']?.value && f['slotName']?.value && isBedSlotEnabled">-{{
            f['slotName']?.value
            }}</span></ion-text>
      </ion-item>
      <ion-item class="form-item-detail indent-item-detail" [detail]="!isReadMode"
        [ngClass]="{'interactive': !isReadMode}" (click)="setBedSlot()" [disabled]="!f['roomName']?.value"
        *ngIf="isBedSlotEnabled && !isReadMode">
        <ion-label>Bed Slot</ion-label>
        <ion-text slot="end" [class.app-link]="f['slotName']?.value && isReadMode"
          [class.no-link]="!isRoomSummaryEnabled" [class.none-value]="!f['slotName']?.value">{{f['slotName']?.value ||
          'None'}}</ion-text>
      </ion-item>
      <ion-item class="form-item-detail" [detail]="!isReadMode" [ngClass]="{'interactive': !isReadMode}"
        (click)="setResident()" *ngIf="isReadMode">
        <ion-label>Resident</ion-label>
        <ion-text slot="end" [class.app-link]="f['residentName']?.value && isReadMode"
          [class.no-link]="!isWearerSummaryEnabled"
          [class.none-value]="!f['residentName']?.value">{{f['residentName']?.value ||
          (isReadMode ? 'Unassigned' : 'None')}}</ion-text>
      </ion-item>
      <ion-item class="form-item-detail" *ngIf="isReadMode && f['connexioEnabled']?.value" (click)="setBridge()">
        <ion-label>Bridge</ion-label>
        <ion-text slot="end" [class.app-link]="f['bridgeName']?.value && isReadMode"
          [class.no-link]="!isBridgeSummaryEnabled"
          [class.none-value]="!f['bridgeName']?.value">{{f['bridgeName']?.value ||
          (isReadMode ? 'Unassigned' : 'None')}}</ion-text>
      </ion-item>

      <div *ngIf="isReadMode">
        <div class="section-label">Devices</div>
        <ion-item class="form-item-detail first-item-border" *ngIf="bedDetails?.deviceDetails?.macId">
          <ion-label>{{bedDetails?.deviceDetails?.providerName}} {{bedDetails?.deviceDetails?.modelName}}</ion-label>
          <ion-text slot="end" (click)="navigateToDeviceManagement(bedDetails?.deviceDetails)"
            [ngClass]="{'app-link': isDeviceManagementEnabled}">{{bedDetails?.deviceDetails?.macId}}</ion-text>
        </ion-item>
        <ion-item class="form-item-detail" *ngIf="!bedDetails?.deviceDetails?.macId" class="no-border" lines="none">
          <ion-label>No associated devices</ion-label>
        </ion-item>
      </div>

      <!-- <ion-item *ngIf="!isReadMode && !isAdmin">
        <ion-note class="app-note">To edit other fields, sign in as an admin user.</ion-note>
      </ion-item> -->
    </div>
  </form>
  <div class="delete-bed" *ngIf="bedId && isReadMode">
    <ion-button color="danger" (click)="deleteBed()" [nAccess]="'deleteBed'">Delete This Bed</ion-button>
  </div>
</ion-content>